// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ToTopOutlinedSvg from "@ant-design/icons-svg/es/asn/ToTopOutlined";
import AntdIcon from '../components/AntdIcon';

var ToTopOutlined = function ToTopOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: ToTopOutlinedSvg
  }));
};

ToTopOutlined.displayName = 'ToTopOutlined';
export default React.forwardRef(ToTopOutlined);